/**
 * Created by greg on 22/06/2018.
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { style, state, animate, transition, trigger} from "@angular/animations";

@Component({
    selector: 'collapsible',
    animations: [
        trigger('slider', [
            state('expand', style({ height: '*' })),
            state('collapse, void', style({ height: '0', padding:0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])],
    template: `
        <div class="collapsible">
            <div class="toggle" (click)="toggled = !toggled">
                <mat-icon *ngIf="!toggled">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="toggled">keyboard_arrow_up</mat-icon>
                <ng-content select="[collapsible-toggle]"></ng-content>
            </div>
            <div class="content {{loaded}}" [@slider]="toggled ? 'expanded' : 'collapse'">
                <ng-content select="[collapsible-content]"></ng-content>
            </div>
        </div>
    `,
    styles: [`
        .content { 	overflow: hidden; display:none; padding-top:10px;}
        .content.loaded { display: block; }
        .toggle mat-icon { float: right; color: #999; }
    `]
})
export class CollapsibleComponent {
    toggled:boolean = false;
    loaded = '';
    constructor(){
        setTimeout(_=>{
            this.loaded = 'loaded';
        },3000); // set this so that you don't have a flash
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/collapsible.component.ts